import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useLang } from "../../i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#1C1917] text-[#F3EFE6] pt-20 pb-10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo light testId="footer-logo" />
            <p className="mt-6 text-sm text-[#D6CFC4] max-w-sm leading-relaxed">{t("ft.desc")}</p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#E2C9A6]">{t("ft.navigate")}</p>
            <ul className="mt-4 space-y-2 text-sm">
              {[["Qualità", "#qualita"], ["Prodotti", "#prodotti"], ["Contatti", "#contatti"]].map(([l, h]) => (
                <li key={h}><a href={h} data-testid={`footer-link-${h.slice(1)}`} className="link-underline">{l}</a></li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4 text-sm text-[#D6CFC4] space-y-2">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#E2C9A6]">{t("ft.legal")}</p>
            <p>Kashmiracompany</p>
            <p>{t("ft.vat")}</p>
            <p>{t("ft.addr")}</p>
          </div>
        </div>
        <p className="mt-20 font-serif font-light text-[18vw] leading-none tracking-tighter text-[#F3EFE6]/10 select-none whitespace-nowrap">cashmere</p>
        <div className="mt-6 pt-6 border-t border-[#3A322C] flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#A8A29E]">
          <span>© {new Date().getFullYear()} Kashmira&amp;Co. {t("ft.rights")}</span>
          <span>
            <Link to="/privacy" data-testid="footer-link-privacy" className="link-underline">{t("ft.privacy")}</Link>
            {" · "}
            <Link to="/cookie-policy" data-testid="footer-link-cookie" className="link-underline">{t("ft.cookie")}</Link>
          </span>
        </div>
      </div>
    </footer>
  );
};
